'use strict';

var $		= require('jquery');
var React 	= require('react');

var EquipmentSearch 		= require('./views/equipment-search-view.jsx');
var CourseSearch 			= require('./views/course-search-view.jsx');
var NewsSearch 				= require('./views/news-search-view.jsx');
var TipsSearch 				= require('./views/tips-search-view.jsx');

var componentNames = {
	equipmentSearchDesktop: 'equipment-search-desktop',
	equipmentSearchMobile: 'equipment-search-mobile',
	courseSearchDesktop: 'course-search-desktop',
	courseSearchMobile: 'course-search-mobile',
	newsSearchDesktop: 'news-search-desktop',
	newsSearchMobile: 'news-search-mobile',
	tipsSearchDesktop: 'tips-search-desktop',
	tipsSearchMobile: 'tips-search-mobile'
};

function renderView(component, componentName, context, dataElement) {
	var container = $('[data-jsx="' + componentName + '"]', context);

	if (container.length > 0) {
		var element = React.createElement(component, dataElement.length > 0 ? dataElement.data() : container.data());
		React.render(element, container[0]);
	}
}

module.exports = {
	render: function (context) {
		var dataElement = '';

		dataElement = $('#equipmentReviewSearchFilters');
		renderView(EquipmentSearch, componentNames.equipmentSearchDesktop, context, dataElement);
		renderView(EquipmentSearch, componentNames.equipmentSearchMobile, context, dataElement);
		
		dataElement = $('#courseReviewSearchFilters');
		renderView(CourseSearch, componentNames.courseSearchDesktop, context, dataElement);
		renderView(CourseSearch, componentNames.courseSearchMobile, context, dataElement);

		dataElement = $('#newsSearchFilters');
		renderView(NewsSearch, componentNames.newsSearchDesktop, context, dataElement);
		renderView(NewsSearch, componentNames.newsSearchMobile, context, dataElement);

		dataElement = $('#tipsSearchFilters');
		renderView(TipsSearch, componentNames.tipsSearchDesktop, context, dataElement);
		renderView(TipsSearch, componentNames.tipsSearchMobile, context, dataElement);
	}
};